export default __webpack_public_path__ + "static/with-pencil-2aadf7456dd22dbdd5d0d24eab2787c2.png";